import { AfterContentChecked } from '@angular/core';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CLPUser, UserResponse } from './models/clpuser.model';
import { GlobalService } from './services/shared/global.service';
import { LocalService } from './services/shared/local.service';
import { SessionService } from './services/shared/session.service';
import { UtilityService } from './services/shared/utility.service';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})

export class AppComponent implements AfterContentChecked {
    private destroy$ = new Subject<void>();
    encryptedUser: string; user: CLPUser;
    userResponse: UserResponse;
    incomingUrl: string;
    isCmManager: boolean = false;
    isCmSite: boolean = false;
    isMembership: boolean = false;
    isShowMenu: boolean = false;
    isContract: boolean = false;
    isClientContract: boolean = false;

    constructor(public _localService: LocalService,
        private titleService: Title,
        private _utilityService: UtilityService,
        private _globalSErvice: GlobalService,
        private _route: ActivatedRoute,
        private cdref: ChangeDetectorRef,
        private _router: Router,
        private sessionService: SessionService
    ) {
        this.titleService.setTitle('Club Manager');

        this._localService.isCmManager.pipe(takeUntil(this.destroy$)).subscribe(value => {
            this.isCmManager = value;
            this.isCmSite = false;
            this.isMembership = false;
        })
        this._localService.isCmSite.pipe(takeUntil(this.destroy$)).subscribe(value => {
            this.isCmSite = value;
            this.isCmManager = false;
            this.isMembership = false;
        })
        this._localService.isMembership.pipe(takeUntil(this.destroy$)).subscribe(value => {
            this.isMembership = value;
            this.isCmSite = false;
            this.isCmManager = false;
        })

        this._localService.isShowMenu.pipe(takeUntil(this.destroy$)).subscribe(value => this.isShowMenu = value)
        this._localService.isContract.pipe(takeUntil(this.destroy$)).subscribe(value => this.isContract = value)
        this._localService.isClientContract.pipe(takeUntil(this.destroy$)).subscribe(value => this.isClientContract = value)

    }

    ngOnInit() {
        if (localStorage.getItem('title'))
            this.titleService.setTitle(localStorage.getItem('title'));
        //this.sessionService.markLoggedIn();
        this.sessionService.startPolling();

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.sessionService.clearPooling();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

}
